import React, { useEffect, useState } from 'react';
import { apiRaw } from '../../api';
import { FaMapMarkerAlt } from 'react-icons/fa';
import Modal from 'react-modal';
import './FilterByLocation.css';
import baseURL from '../url';
import { useMediaQuery } from '@react-hook/media-query';
import { useLocalStorage } from '../../Context/LocalStorageContext';

export default function FilterByLocation() {
  const [estados, setEstados] = useState([]);
  const [ciudades, setCiudades] = useState([]);
  const [selectedEstado, setSelectedEstado] = useState(22);
  const [selectedCiudad, setSelectedCiudad] = useState('');
  const [ciudadLS, setCiudadLS] = useLocalStorage('ciudad');
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const isScreenLarge = useMediaQuery('(min-width: 1024px)'); // Detecta si es desktop

  useEffect(() => {
    cargarEstados();
  }, []);
  useEffect(() => {
    cargarCiudades(22);
  }, []);

  const cargarEstados = () => {
    apiRaw(`/estados?country_id=1`, { method: 'GET' })
      .then((response) => response.json())
      .then((data) => {
        setEstados(data.estados || []);
      })
      .catch((error) => console.error('Error al cargar estados:', error));
  };

  const cargarCiudades = (estadoId) => {
    apiRaw(`/ciudades?states_id=${estadoId}`, { method: 'GET' })
      .then((response) => response.json())
      .then((data) => {
        setCiudades(data.ciudades || []);
      })
      .catch((error) => console.error('Error al cargar ciudades:', error));
  };

  const handleEstadoChange = (e) => {
    const estadoId = e.target.value;
    setSelectedEstado(estadoId);
    setSelectedCiudad('');
    cargarCiudades(estadoId);
  };

  const handleCiudadChange = (e) => {
    setSelectedCiudad(e.target.value);
    setCiudadLS(e.target.value);
  };

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  return (
    <div className="filter-location-container">
      {isScreenLarge ? (
        // Versión para pantallas grandes (desktop)
        <div className="dropdown-container">
          <div className="dropdown-wrapper">
            <FaMapMarkerAlt className="dropdown-icon" />
            <select
              className="dropdown"
              value={selectedEstado}
              onChange={handleEstadoChange}
              disabled={true}
            >
              <option value="">Estado</option>
              {estados.map((estado) => (
                <option key={estado.id} value={estado.id}>
                  {estado.name}
                </option>
              ))}
            </select>
          </div>

          <div className="dropdown-wrapper">
            <FaMapMarkerAlt className="dropdown-icon" />
            <select
              className="dropdown"
              value={selectedCiudad}
              onChange={handleCiudadChange}
              disabled={!selectedEstado}
            >
              <option value="">Todas las ciudades</option>
              {ciudades.map((ciudad) => (
                <option key={ciudad.id} value={ciudad.id}>
                  {ciudad.name}
                </option>
              ))}
            </select>
          </div>
        </div>
      ) : (
        // Versión para pantallas móviles (ícono de ubicación)
        <div className="mobile-location-icon" onClick={openModal}>
          <FaMapMarkerAlt size={24} color="#14A7A3" />
        </div>
      )}

      {/* Modal para dispositivos móviles */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        className="modalLocation"
        overlayClassName="overlayLocation"
      >
        <div className="modal-content">
          <h3>Seleccionar Ubicación</h3>
          <div className="dropdown-container">
            <div className="dropdown-wrapper">
              <FaMapMarkerAlt className="dropdown-icon" />
              <select
                className="dropdown"
                value={selectedEstado}
                onChange={handleEstadoChange}
                disabled={true}
              >
                <option value="">Estado</option>
                {estados.map((estado) => (
                  <option key={estado.id} value={estado.id}>
                    {estado.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="dropdown-wrapper">
              <FaMapMarkerAlt className="dropdown-icon" />
              <select
                className="dropdown"
                value={selectedCiudad}
                onChange={handleCiudadChange}
                disabled={!selectedEstado}
              >
                <option value="">Todas las ubicaciones</option>
                {ciudades.map((ciudad) => (
                  <option key={ciudad.id} value={ciudad.id}>
                    {ciudad.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <button onClick={closeModal} className="close-modal-btn">
            Cerrar
          </button>
        </div>
      </Modal>
    </div>
  );
}
